import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { Input } from 'dibs-elements/exports/Input';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { TextArea } from 'dibs-elements/exports/TextArea';
import SwitchButton from '../Toolbar/SwitchButton';
import { Button } from 'dibs-elements/exports/Button';

// Helpers
import actions from '../../actions/FavoritesActions';
import { copy, cutoffs, deviceTypes, mutations, privacySettings } from '../../constants';

// Styles
import styles from './styles/PortfolioCreationModal.scss';

const PortfolioCreationModal = props => {
    const { newPortfolioDescription, newPortfolioName, newPortfolioPrivacy } = props;

    const createFolder = () => {
        props.onClick({
            action: mutations.types.ADD,
            description: newPortfolioDescription,
            name: newPortfolioName,
            privacyLevel: newPortfolioPrivacy,
        });
    };

    const updatePrivacy = () => {
        if (newPortfolioPrivacy === privacySettings.PUBLIC) {
            props.setPortfolioPrivacy(privacySettings.PRIVATE);
        } else {
            props.setPortfolioPrivacy(privacySettings.PUBLIC);
        }
    };

    return (
        <ModalContainer
            dataTn="portfolio-creation"
            onClose={props.closeModal}
            isOpen={props.modalOpen}
            modalPosition="center"
        >
            <ModalCloseButton onClick={props.closeModal} />
            <BarHeader dataTn="portfolio-creation" title={props.title} />
            <ModalBody dataTn="portfolio-creation">
                <div className={styles.input}>
                    <Input
                        dataTn="portfolio-creation-modal-name"
                        maxLength={cutoffs.MAX_CHAR_TITLE}
                        onChange={e => props.setNewPortfolioName(e.target.value)}
                        placeholder={copy.createFolder.PLACEHOLDER_NAME}
                        showCount
                        type="text"
                        value={newPortfolioName}
                    />
                </div>
                <div className={styles.textArea}>
                    <TextArea
                        dataTn="portfolio-creation-modal-description"
                        maxLength={cutoffs.MAX_CHAR_DESCRIPTION}
                        onChange={e => props.setPortfolioDescription(e.target.value)}
                        placeholder={copy.createFolder.PLACEHOLDER_DESCRIPTION}
                        isMobile={props.deviceType === deviceTypes.MOBILE}
                        value={newPortfolioDescription}
                    />
                </div>
                <div className={styles.toggle}>
                    <SwitchButton
                        dataTn="portfolio-creation-modal-toggle"
                        containerClass={styles.switch}
                        labelClass={styles.label}
                        offText="No"
                        onSwitch={updatePrivacy}
                        onText="Yes"
                        switchLabel={copy.createFolder.SWITCH_LABEL}
                        switchOn={newPortfolioPrivacy === privacySettings.PUBLIC}
                    />
                    <span className={styles.explanation}>
                        {copy.createFolder.SWITCH_DESCRIPTION}
                    </span>
                </div>
                <div className={styles.submit}>
                    <Button
                        dataTn="portfolio-creation-modal-submit"
                        onClick={createFolder}
                        disabled={newPortfolioName === ''}
                        fullWidth
                        size="large"
                    >
                        {copy.createFolder.SUBMIT}
                    </Button>
                </div>
            </ModalBody>
        </ModalContainer>
    );
};

PortfolioCreationModal.propTypes = {
    setPortfolioPrivacy: PropTypes.func,
    setNewPortfolioName: PropTypes.func,
    deviceType: PropTypes.string,
    closeModal: PropTypes.func,
    description: PropTypes.string,
    mutationResponse: PropTypes.string,
    newPortfolioDescription: PropTypes.string,
    newPortfolioName: PropTypes.string,
    newPortfolioPrivacy: PropTypes.string,
    onClick: PropTypes.func,
    modalOpen: PropTypes.bool,
    openModalType: PropTypes.string,
    setPortfolioDescription: PropTypes.func,
    title: PropTypes.string,
};

const mapStateToProps = state => {
    return {
        deviceType: state.favorites.uiState.deviceType,
        newPortfolioDescription: state.favorites.creationState.newPortfolioDescription,
        newPortfolioName: state.favorites.creationState.newPortfolioName,
        newPortfolioPrivacy: state.favorites.creationState.newPortfolioPrivacy,
        editInline: state.favorites.editInlineState.editInline,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setEditInline: editInline => {
            dispatch(actions.setEditInline({ editInline }));
        },
        setPortfolioDescription: newPortfolioDescription => {
            dispatch(actions.setPortfolioDescription({ newPortfolioDescription }));
        },
        setNewPortfolioName: newPortfolioName => {
            dispatch(actions.setNewPortfolioName({ newPortfolioName }));
        },
        setPortfolioPrivacy: newPortfolioPrivacy => {
            dispatch(actions.setPortfolioPrivacy({ newPortfolioPrivacy }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PortfolioCreationModal);
